//First number (2,3,4,5,6, 7) is positionId of template active
export const CATEGORIES_ORDER = {
    //Defender
    2:{
      //Passing
      10: 1,
      //Saving
      11: 5,
      //Defending
      12: 3,
      //Shooting
      13: 6,
      //Ball Handling
      14: 7,
      //Association
      15: 2,
      //Aerial
      16: 4,
      //Crosses
      60: 8,
      //Carries
      61: 9,
      //Turnovers
      63: 10,
      //Sequence Involvement
      64: 11,
    },
    //FullBack
    3: {
      10: 1,
      11: 6,
      12: 4,
      13: 7,
      14: 3,
      15: 2,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
    },
    //Midfielder
    4: {
      10: 1,
      11: 6,
      12: 4,
      13: 7,
      14: 3,
      15: 2,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
    },
    //Winger
    5: {
      10: 6,
      11: 7,
      12: 4,
      13: 1,
      14: 2,
      15: 3,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
    },
    //Forward
    6: {
      10: 3,
      11: 7,
      12: 6,
      13: 1,
      14: 2,
      15: 4,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
    },
    //WingBack
    7: {
      10: 1,
      11: 6,
      12: 4,
      13: 7,
      14: 3,
      15: 2,
      16: 5,
      60: 8,
      61: 9,
      63: 10,
      64: 11,
    },
}

export default CATEGORIES_ORDER;



// WEBPACK FOOTER //
// ./src/views/player/categories_order.js